export const AnchorReveal = ({ anchor }: { anchor: string }) => {
  const href = `#${anchor}`

  const copyAnchor = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    const url = new URL(window.location.href)
    url.hash = anchor

    await navigator.clipboard?.writeText(url.toString())
  }

  return (
    <a
      aria-label="Copy anchor link"
      href={href}
      className="anchor-reveal"
      onClick={copyAnchor}
    >
      #
    </a>
  )
}
